export default function FormatNumberWithThousandsSeparator(value) {
  if (typeof value === 'number') {
    return value.toLocaleString('fr-FR', { maximumFractionDigits: 0, minimumFractionDigits: 0 });
  }
  return value;
}
